import { render, staticRenderFns } from "./dwelling-queue-table.vue?vue&type=template&id=4a9b4c2e&scoped=true"
import script from "./dwelling-queue-table.vue?vue&type=script&lang=js"
export * from "./dwelling-queue-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b4c2e",
  null
  
)

export default component.exports